import { useTheme } from "app/shared";
import { FC } from "react";
import styles from "./TeamSection.module.scss";

interface TeamMember {
  name: string;
  position: string;
  description: string;
  photoUrl?: string;
}

interface TeamSectionProps {
  team: TeamMember[];
}

const TeamSection: FC<TeamSectionProps> = ({ team }) => {
  const { theme } = useTheme();

  return (
    <div
      className={`${styles.container} ${
        theme === "dark" ? styles.darkTheme : ""
      }`}
    >
      <h2 className={styles.title}>Core Team</h2>
      <div className={styles.teamGrid}>
        {team.map((member, index) => (
          <div
            key={index}
            className={`${styles.memberCard} ${
              theme === "dark" ? styles.darkTheme : ""
            }`}
          >
            {member.photoUrl && (
              <div className={styles.memberPhotoContainer}>
                <img
                  src={member.photoUrl}
                  alt={member.name}
                  className={styles.memberPhoto}
                  onError={(e) =>
                    ((e.target as HTMLImageElement).style.display = "none")
                  }
                />
              </div>
            )}
            <p className={styles.memberPosition}>{member.position}:</p>
            <p
              className={`${styles.memberDescription} ${
                theme === "dark" ? styles.darkTheme : ""
              }`}
            >
              {member.description}
            </p>
            <h3
              className={`${styles.memberName} ${
                theme === "dark" ? styles.darkTheme : ""
              }`}
            >
              {member.name}
            </h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TeamSection;
